import React, { useMemo, useRef } from "react";
import { Dropdown, Form, Menu } from "@pionex-web-kit/components";
import { CoinIcon } from "components/CoinIcon";
import { IconDropDownArrow12pxBold } from "@pionex-web-kit/icons";
import { BuyCryptoConfig } from "landings/V2/BuyCrypto/types";
import { useTranslators } from "commonUse/Locale";
import FormItemTransition from "utils/FormItemTransition";
import { useDWCoins } from "commonUse/useDW";
import { DropdownCoinItem } from "landings/V2/BuyCrypto/components/Form/items/DropdownCoinItem";

interface Props {
    coins?: BuyCryptoConfig["coins"];
}

const DEFAULT_QUOTE = "USD";

/**
 * 选择币种的FormItem
 */
const SelectCoinItem: React.FC<Props> = ({ coins }) => {
    const { $st } = useTranslators();
    const [dwCoins] = useDWCoins();
    const allCoinsMap = useMemo(() => {
        return new Map(dwCoins.map((item) => [item.coinName, item]));
    }, [dwCoins]);
    return (
        <Form.Item className="mb-0" name="coin" rules={[{ required: true }]}>
            <FormItemTransition<string>>
                {({ value, onChange }) => {
                    const coinInfo = coins?.find((item) => item.coin === value);
                    return (
                        <Dropdown
                            trigger={["click"]}
                            overlay={
                                <Menu>
                                    <div className="text-secondary px-[12px] pt-[10px]">{$st("buy_crypto_choose_asset_header")}</div>
                                    {coins?.map(({ coin }) => {
                                        return (
                                            <div>
                                                <Menu.Item
                                                    className="block"
                                                    key={coin}
                                                    onClick={(v) => {
                                                        onChange?.(coin);
                                                    }}
                                                >
                                                    <DropdownCoinItem coin={coin} quote={DEFAULT_QUOTE} allCoinsMap={allCoinsMap} />
                                                </Menu.Item>
                                                <div className="bg-divider h-1px mx-[12px]" />
                                            </div>
                                        );
                                    })}
                                </Menu>
                            }
                            onItemClick={(v) => {
                                onChange?.(v.key);
                            }}
                        >
                            <div className={"flex justify-between items-center font-b cursor-pointer text-lg h-[52px]"}>
                                {$st("buy_crypto_select_coin")}
                                <div className="flex items-center">
                                    {!!coinInfo && (
                                        <>
                                            <CoinIcon target={coinInfo.coin} className="mr-8px !w-24px !h-24px" />
                                            {allCoinsMap.get(coinInfo.coin)?.fullName || coinInfo.coin} {`(${coinInfo.coin})`}
                                        </>
                                    )}
                                    <IconDropDownArrow12pxBold size={14} className="ml-12px" />
                                </div>
                            </div>
                        </Dropdown>
                    );
                }}
            </FormItemTransition>
        </Form.Item>
    );
};
export default SelectCoinItem;
